import { LogDefinitionTypes } from '../../../../noctem-lib/src/constants/constants';
import { FieldDefinitionBase, FieldType, UnitType, AssessmentFieldDefinition,
         AssessmentGroupScoreFieldDefinition } from '../../../../noctem-lib/src/core/contracts/models.calculations';

export const ess: Array<FieldDefinitionBase> =
[

//#endregion
  new AssessmentGroupScoreFieldDefinition({
    _type: FieldType.AssessmentGroupScore,
    name: 'ess-overall',
    unit: UnitType.Number,
    abbreviation: 'ESS Weekly Overall',
    description: `ESS Weekly Overall`,
    assessmentType: LogDefinitionTypes.ESS
  }),
  new AssessmentFieldDefinition({
    _type: FieldType.Assessment,
    name: 'ess-sleep-read',
    unit: UnitType.Number,
    abbreviation: '',
    description: ``,
    assessmentType: LogDefinitionTypes.ESS,
    answerId: 'ESS_SLEEP_READ'
  }),
  new AssessmentFieldDefinition({
    _type: FieldType.Assessment,
    name: 'ess-sleep-tv',
    unit: UnitType.Number,
    abbreviation: '',
    description: ``,
    assessmentType: LogDefinitionTypes.ESS,
    answerId: 'ESS_SLEEP_TV'
  }),
  new AssessmentFieldDefinition({
    _type: FieldType.Assessment,
    name: 'ess-sleep-public',
    unit: UnitType.Number,
    abbreviation: '',
    description: ``,
    assessmentType: LogDefinitionTypes.ESS,
    answerId: 'ESS_SLEEP_PUBLIC'
  }),
  new AssessmentFieldDefinition({
    _type: FieldType.Assessment,
    name: 'ess-sleep-car',
    unit: UnitType.Number,
    abbreviation: '',
    description: ``,
    assessmentType: LogDefinitionTypes.ESS,
    answerId: 'ESS_SLEEP_CAR'
  }),
  new AssessmentFieldDefinition({
    _type: FieldType.Assessment,
    name: 'ess-sleep-afternoon',
    unit: UnitType.Number,
    abbreviation: '',
    description: ``,
    assessmentType: LogDefinitionTypes.ESS,
    answerId: 'ESS_SLEEP_AFTERNOON'
  }),
  new AssessmentFieldDefinition({
    _type: FieldType.Assessment,
    name: 'ess-sleep-talk',
    unit: UnitType.Number,
    abbreviation: '',
    description: ``,
    assessmentType: LogDefinitionTypes.ESS,
    answerId: 'ESS_SLEEP_TALK'
  }),
  new AssessmentFieldDefinition({
    _type: FieldType.Assessment,
    name: 'ess-lunch-no-alcohol',
    unit: UnitType.Number,
    abbreviation: '',
    description: ``,
    assessmentType: LogDefinitionTypes.ESS,
    answerId: 'ESS_LUNCH_NO_ALOCHOL'
  }),
  new AssessmentFieldDefinition({
    _type: FieldType.Assessment,
    name: 'ess-sleep-traffic',
    unit: UnitType.Number,
    abbreviation: '',
    description: ``,
    assessmentType: LogDefinitionTypes.ESS,
    answerId: 'ESS_SLEEP_TRAFFIC'
  }),
  //#endregion
];
